import ItemVariation from 'src/models/item/ItemVariation'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import Modifier from 'src/models/modifier-set/Modifier'

export default class InventoryRecipeTrigger extends Model {
  static name = 'InventoryRecipeTrigger'

  static versioned = true

  static deletable = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Inventory]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      name: {
        type: String,
        output: true
      },
      itemVariation: {
        type: ItemVariation,
        encode: encoders.hasOne,
        reference: true,
        default: null
      },
      modifier: {
        type: Modifier,
        encode: encoders.hasOne,
        reference: true,
        default: null
      },
      recipeQuantity: {
        type: Number
      },
      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      },
      receiveLibraryUpdates: {
        type: Boolean,
        output: true,
        excludeFromDefault: true
      }
    }
  }
}
